import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { ScannerCase } from 'models/scanner-case';
import { Box } from '@mui/system';
import { Button } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useMutation } from '@apollo/client';
import { attachScannerCaseToOrderTemplate } from 'apollo/templates/scanner-case';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';
import ScannerCasePreview from '../scanner-case-dialog/scanner-case-preview/scanner-case-preview.component';

type AttachScannerCaseListItemProps = {
    orderId: string;
    scannerCase: ScannerCase;
    onAttachScannerCase: (scannerCase: ScannerCase) => void;
};
const AttachScannerCaseListItem: FC<AttachScannerCaseListItemProps> = ({
    orderId,
    scannerCase,
    onAttachScannerCase,
}) => {
    const { t: translate } = useTranslation(['scan-cases', 'three-shape']);
    const { showBoundary } = useDenthubErrorBoundary();

    const [attachScannerCaseToOrder] = useMutation(attachScannerCaseToOrderTemplate, {
        onCompleted: () => {
            onAttachScannerCase(scannerCase);
        },
        onError: (error) => {
            showBoundary(error);
        },
    });

    const attachScanCase = () => {
        attachScannerCaseToOrder({
            variables: {
                orderId,
                scannerCaseId: scannerCase._id,
            },
        });
    };

    return (
        <Fragment>
            <Box display="flex">
                <Box flex="1 1 auto">
                    <Box mb={2}>
                        <ScannerCasePreview scannerCase={scannerCase} />
                    </Box>
                </Box>
                <Box ml={2} sx={{ minWidth: 200 }} justifySelf="flex-end">
                    <Button fullWidth variant="contained" startIcon={<AddCircleIcon />} onClick={attachScanCase}>
                        {translate('scan-cases:ATTACH_FILES')}
                    </Button>
                </Box>
            </Box>
        </Fragment>
    );
};

export default AttachScannerCaseListItem;
